import { Box, Pagination } from '@mui/material'
import { useEffect } from 'react'
import './PaginationComp.scss'

interface paginationProps {
  data: any,
  setCurData: any,
  pageNum: any,
  setPageNum: any,
  dataLength: number,
  itemsPerPage: number
}

const PaginationComp = (props: paginationProps) => {

  const { data, setPageNum, setCurData, dataLength, itemsPerPage, pageNum } = props

  const totalPages = Math.ceil(dataLength / itemsPerPage)

  const handlePageChange = (event:any, page:number) => {
    setPageNum(page);
  }

  useEffect(() => {
    const endIdx = pageNum * itemsPerPage;
    const startIdx = endIdx - itemsPerPage;
    setCurData(data.slice(startIdx, endIdx));
    // eslint-disable-next-line
  }, [data, pageNum])

  return (
    <Box justifyContent={'center'} alignItems={'center'} display={'flex'} sx={{margin: '20px 0px'}}>
      <Pagination 
        count={totalPages}
        onChange={handlePageChange}
      />
    </Box>
  )
}

export default PaginationComp